import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=35b49500&scoped=true&"
import script from "./CalendarView.vue?vue&type=script&lang=js&"
export * from "./CalendarView.vue?vue&type=script&lang=js&"
import style0 from "./CalendarView.vue?vue&type=style&index=0&id=35b49500&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b49500",
  null
  
)

export default component.exports